var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "81px",
    viewBox: "0 0 80 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000180451128 0.383759398 79.6156391 0.383759398 79.6156391 79.9999398 0.000180451128 79.9999398"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 80.2177444 79.6156391 80.2177444 79.6156391 0.601503759 0 0.601503759"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobil-\\u2013-Desktop",
    transform: "translate(-223.000000, -991.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(223.000000, 991.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.217744)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6158195,40.1918195 C79.6158195,62.1773835 61.7932632,79.9999398 39.8070977,79.9999398 C17.8227368,79.9999398 0.000180451128,62.1773835 0.000180451128,40.1918195 C0.000180451128,18.2062556 17.8227368,0.383699248 39.8070977,0.383699248 C61.7932632,0.383699248 79.6158195,18.2062556 79.6158195,40.1918195",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.509594,20.3702256 C30.0701955,20.3702256 28.9008722,21.5401504 28.9008722,22.9789474 L28.9008722,52.7118797 C28.9008722,54.1494737 30.0701955,55.32 31.509594,55.32 L45.7002707,55.32 C47.1372632,55.32 48.308391,54.1494737 48.308391,52.7118797 L48.308391,22.9789474 C48.308391,21.5401504 47.1372632,20.3702256 45.7002707,20.3702256 L31.509594,20.3702256 Z M45.7002707,55.8962406 L31.509594,55.8962406 C29.7538045,55.8962406 28.3258346,54.4676692 28.3258346,52.7118797 L28.3258346,22.9789474 C28.3258346,21.2231579 29.7538045,19.7945865 31.509594,19.7945865 L45.7002707,19.7945865 C47.4554586,19.7945865 48.8840301,21.2231579 48.8840301,22.9789474 L48.8840301,52.7118797 C48.8840301,54.4676692 47.4554586,55.8962406 45.7002707,55.8962406 L45.7002707,55.8962406 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "28.6123308 23.2661654 48.5960902 23.2661654 48.5960902 22.6911278 28.6123308 22.6911278"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "34.3843609 21.4544361 42.1630075 21.4544361 42.1630075 21.2090226 34.3843609 21.2090226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "28.6123308 52.1852632 48.5960902 52.1852632 48.5960902 51.9386466 28.6123308 51.9386466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6025263,52.7468872 C38.0425263,52.7468872 37.5877895,53.2010226 37.5877895,53.7610226 C37.5877895,54.3186165 38.0425263,54.7733534 38.6025263,54.7733534 C39.1613233,54.7733534 39.6160602,54.3186165 39.6160602,53.7610226 C39.6160602,53.2010226 39.1613233,52.7468872 38.6025263,52.7468872 M38.6025263,54.9387669 C37.9529023,54.9387669 37.424782,54.4094436 37.424782,53.7610226 C37.424782,53.1101955 37.9529023,52.5832782 38.6025263,52.5832782 C39.2515489,52.5832782 39.7802707,53.1101955 39.7802707,53.7610226 C39.7802707,54.4094436 39.2515489,54.9387669 38.6025263,54.9387669",
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "54.0436692 58.1627669 40.0256241 58.1627669 43.6346466 39.699609 54.6451729 39.6466767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2818045,52.9606617 C48.2818045,52.9606617 46.4045113,51.9790075 46.0706767,50.7663759 C46.0706767,50.7663759 43.5533835,50.7741955 42.8069173,52.3934436 C42.0622556,54.0108872 41.6790977,56.5612632 41.6790977,56.5612632 C41.6790977,56.5612632 42.9338346,58.6352481 48.444812,58.6352481 C53.9557895,58.6352481 54.8833083,56.5612632 54.8833083,56.5612632 C54.8833083,56.5612632 54.9639098,54.0758496 53.7915789,52.3934436 C52.6186466,50.7110376 50.6198496,50.7663759 50.6198496,50.7663759 C50.277594,52.0331429 48.2818045,52.9606617 48.2818045,52.9606617",
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.760782,46.1755789 C52.6699549,45.7575338 52.2470977,45.2576842 52.0167218,45.6366316 C51.6846917,43.8339248 50.5201805,42.5924211 48.4678496,42.5737744 C46.4161203,42.5924211 45.2534135,43.8339248 44.920782,45.6366316 C44.690406,45.2576842 44.2681504,45.7575338 44.1767218,46.1755789 C44.0642406,46.6928722 44.4858947,47.9758797 45.0134135,47.7214436 C45.0801805,48.6573835 45.0771729,49.0224962 45.5138647,49.5024962 C46.2260451,50.2850526 47.329203,51.0988872 48.4678496,51.1259549 C49.6083008,51.0988872 50.7114586,50.2850526 51.4230376,49.5024962 C51.8603308,49.0224962 51.8561203,48.6573835 51.9234887,47.7214436 C52.450406,47.9758797 52.8732632,46.6928722 52.760782,46.1755789",
    id: "Fill-13",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4457143,41.6601504 C45.0261654,41.6601504 44.9209023,45.2541353 44.9209023,45.2541353 C44.9209023,45.2541353 46.9124812,44.8294737 48.6285714,44.8294737 C50.3446617,44.8294737 52.0168434,45.2541353 52.0168434,45.2541353 C52.0168434,45.2541353 52.0330827,41.6601504 48.4457143,41.6601504",
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8807218,56.2342857 C54.8723008,55.9828571 54.8482406,55.6027068 54.7844812,55.16 C53.8798195,56.2992481 51.3480902,57.1196992 48.3640301,57.1196992 C45.3835789,57.1196992 42.8542556,56.3004511 41.9465865,55.1642105 C41.8587669,55.5618045 41.792,55.9088722 41.7480902,56.1578947 C42.9348571,57.1239098 45.4503459,57.7891729 48.3640301,57.7891729 C51.1989173,57.7891729 53.6572632,57.157594 54.8807218,56.2342857",
    id: "Fill-15",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5083308,53.9146466 C54.4114887,53.6012632 54.2893835,53.2830677 54.1366015,52.9781053 C53.6800602,54.3531429 51.1862256,55.4057744 48.1781053,55.4057744 C45.4785564,55.4057744 43.1934436,54.5588571 42.4223158,53.3919398 C42.3224662,53.6963008 42.2322406,54.0084812 42.1522406,54.3128421 C43.1429173,55.3480301 45.4683308,56.0752481 48.1781053,56.0752481 C51.2229173,56.0752481 53.7817143,55.1567519 54.5083308,53.9146466",
    id: "Fill-16",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7664361,52.3603609 C53.6082406,52.139609 53.4374135,51.9507368 53.2581654,51.7877293 C52.398015,52.8000602 50.4461353,53.5080301 48.1778647,53.5080301 C45.9619248,53.5080301 44.0515489,52.8343459 43.1607218,51.8599098 C43.0211729,52.0150977 42.9008722,52.1913383 42.8070376,52.3934436 C42.7865865,52.4391579 42.7655338,52.4854737 42.7456842,52.5329925 C43.7116992,53.5050226 45.7808722,54.1775038 48.1778647,54.1775038 C50.714406,54.1775038 52.8822256,53.4256241 53.7664361,52.3603609",
    id: "Fill-17",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9261955,51.2824662 C44.7514586,51.6776541 45.8155188,51.9585564 47.0052932,52.0716391 C46.7454436,51.8412632 46.4976241,51.577203 46.3153684,51.2902857 C45.8197293,51.1988571 45.3589774,51.0713383 44.9403308,50.9155489 C44.6155188,50.9925414 44.2606316,51.1074286 43.9261955,51.2824662",
    id: "Fill-18",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4952782,51.2495639 C52.147609,51.0649023 51.8059549,50.950015 51.510015,50.8796391 C51.177985,51.0107669 50.8146767,51.1202406 50.4279098,51.2092632 C50.2504662,51.5142256 49.9906165,51.7915188 49.7127218,52.0315188 C50.787609,51.8955789 51.7446015,51.6206917 52.4952782,51.2495639",
    id: "Fill-19",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.729985,41.6601504 C48.729985,41.8809023 48.5513383,42.0601504 48.3305865,42.0601504 C48.1092331,42.0601504 47.929985,41.8809023 47.929985,41.6601504 C47.929985,41.4393985 48.1092331,41.2601504 48.3305865,41.2601504 C48.5513383,41.2601504 48.729985,41.4393985 48.729985,41.6601504",
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0633985,44.0421053 L51.8832481,44.0421053 C52.1557293,44.0421053 52.3458045,45.4243609 52.101594,45.4243609 L44.8089624,45.4243609 C44.5809925,45.4243609 44.7909173,44.0421053 45.0633985,44.0421053",
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0998496,47.3338947 C45.0998496,47.3338947 44.8760902,48.5146466 45.1948872,49.0090827 C45.5130827,49.5023158 47.0998496,51.1654737 48.282406,51.1137444 C49.4643609,51.062015 51.4781955,49.8920902 51.6742857,49.1576541 C51.8691729,48.4238195 51.8312782,47.4439699 51.8312782,47.4439699 C51.8312782,47.4439699 51.1196992,48.4250226 50.3918797,48.3889323 C49.6646617,48.3522406 49.1918797,48.0436692 48.4291729,48.0322406 C47.642406,48.022015 47.1070677,48.2920902 46.3726316,48.2247218 C45.5750376,48.1525414 45.0998496,47.3338947 45.0998496,47.3338947",
    id: "Fill-22",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1987368,49.4356692 C49.0158797,49.3141654 47.9343759,49.3652932 47.7322707,49.5072481 C47.5307669,49.6486015 47.5205414,49.1529624 47.702797,48.9406316 C47.8838496,48.7276992 49.068812,48.7078496 49.2510677,48.8702556 C49.4333233,49.0314586 49.3809925,49.5565714 49.1987368,49.4356692",
    id: "Fill-23",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0434286,45.511218 L46.9655338,45.511218 C46.2034286,45.511218 45.3805714,45.4233985 45.3805714,45.9497143 C45.3805714,46.4754286 46.2034286,47.4155789 46.9655338,47.4155789 C47.6813233,47.4155789 48.2713985,47.0384361 48.3381654,46.5554286 C48.3381654,46.5554286 48.355609,46.1776842 48.509594,46.1776842 C48.6202707,46.1776842 48.6539549,46.3749774 48.6653835,46.4832481 C48.665985,46.5067068 48.6677895,46.5295639 48.670797,46.5524211 L48.670797,46.5554286 C48.7375639,47.0384361 49.3270376,47.4155789 50.0434286,47.4155789 C50.8055338,47.4155789 51.5465865,46.4754286 51.5465865,45.9497143 C51.5465865,45.4233985 50.8055338,45.511218 50.0434286,45.511218",
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1418947,46.0269474 C51.1418947,46.2452932 50.6029474,47.0338647 50.0230977,47.0338647 C49.4432481,47.0338647 49.0077594,46.6146165 49.0077594,46.3950677 C49.0077594,46.1767218 49.4366316,45.8489023 50.0170827,45.8489023 C50.5969323,45.8489023 51.1418947,45.8086015 51.1418947,46.0269474",
    id: "Fill-25",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8229173,46.0269474 C45.8229173,46.2452932 46.3618647,47.0338647 46.9411128,47.0338647 C47.5215639,47.0338647 47.9576541,46.6146165 47.9576541,46.3950677 C47.9576541,46.1767218 47.5281805,45.8489023 46.9483308,45.8489023 C46.3672782,45.8489023 45.8229173,45.8086015 45.8229173,46.0269474",
    id: "Fill-26",
    fill: "#3A913F",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile3);
export default __webpack_public_path__ + "static/media/mobile-3.65d5a06426a33bc776c32b92ff32d524.svg";
export { ForwardRef as ReactComponent };